import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.25rem;

  .form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4b6cb7;
      box-shadow: 0 0 0 0.25rem rgba(75, 108, 183, 0.25);
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
`;

const ContactInformation = ({ register, errors }) => {
  const handlePhoneInput = (e) => {
    const allowedKeys = [8, 9, 13, 27, 37, 38, 39, 40, 46];
    if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].includes(e.keyCode)) {
      return;
    }

    if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105) && !allowedKeys.includes(e.keyCode)) {
      e.preventDefault();
    }

    const currentValue = e.target.value;
    if (currentValue.length >= 10 && !allowedKeys.includes(e.keyCode)) {
      e.preventDefault();
    }
  };

  const handlePhonePaste = (e) => {
    const pastedText = e.clipboardData.getData('text');
    if (!/^\d*$/.test(pastedText) || pastedText.length > 10) {
      e.preventDefault();
    }
  };

  return (
    <>
      <h5 className="section-title">Contact Information</h5>
      <Row>
        <StyledFormGroup as={Col} md="6" controlId="email">
          <Form.Label>Email <span className="text-danger">*</span></Form.Label>
          <Form.Control
            type="email"
            {...register('email')}
            isInvalid={!!errors.email}
            placeholder="example@gmail.com"
          />
          <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
            <i className="bi bi-exclamation-circle me-2"></i>
            {errors.email?.message}
          </Form.Control.Feedback>
        </StyledFormGroup>

        <StyledFormGroup as={Col} md="6" controlId="phone">
          <Form.Label>Phone Number <span className="text-danger">*</span></Form.Label>
          <Form.Control
            type="tel"
            {...register('phone')}
            onKeyDown={handlePhoneInput}
            onPaste={handlePhonePaste}
            maxLength="10"
            isInvalid={!!errors.phone}
            placeholder="98XXXXXXXX"
          />
          <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
            <i className="bi bi-exclamation-circle me-2"></i>
            {errors.phone?.message}
          </Form.Control.Feedback>
        </StyledFormGroup>
      </Row>
    </>
  );
};

export default ContactInformation;